import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import CampaignBuilderView from "./CampaignBuilderPage";
import CampaignListView from "./CampaignListView";
import CampaignReviewView from "./CampaignReviewView";

type ViewMode = "list" | "builder" | "review";

export default function CampaignPage() {
  const history = useHistory();
  const query = new URLSearchParams(history.location.search);
  const initialCampaignId = Number(query.get("campaignId")) || null;
  const [view, setView] = useState<ViewMode>(query.get("create") === "true" || initialCampaignId ? "builder" : "list");
  const [campaignId, setCampaignId] = useState<number | null>(initialCampaignId);

  if (view === "builder") {
    return (
      <CampaignBuilderView
        campaignId={campaignId}
        initialServiceId={Number(query.get("serviceId")) || null}
        initialServiceInstanceId={Number(query.get("serviceInstanceId")) || null}
        initialCommunicationType={query.get("communicationType") as "PreRegistration" | "PostRegistration" | null}
        onNext={(id) => {
          setCampaignId(id);
          setView("review");
        }}
        onSaved={(id) => setCampaignId(id)}
        onBack={() => setView("list")}
      />
    );
  }

  if (view === "review") {
    return (
      <CampaignReviewView
        campaignId={campaignId}
        onBack={() => setView("builder")}
        onQueued={() => setView("list")}
      />
    );
  }

  return (
    <CampaignListView
      onCreate={() => {
        setCampaignId(null);
        setView("builder");
      }}
      onEdit={(id) => {
        setCampaignId(id);
        setView("builder");
      }}
      onViewReport={(id) => history.push(`/campaigns/${id}/report`)}
      onBackToDashboard={() => history.push("/dashboard")}
    />
  );
}
